module.exports = __webpack_public_path__ + "static/media/icon-check-circle.ee792eec.svg";